/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCreateAlertForNewResources extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCreateAlertForNewResources");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCreateAlertForNewResources.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCreateAlertForNewResources>): BackgroundJobPayloadForPeriodicCreateAlertForNewResources {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCreateAlertForNewResources(), model);
        BackgroundJobPayloadForPeriodicCreateAlertForNewResources.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCreateAlertForNewResources>): BackgroundJobPayloadForPeriodicCreateAlertForNewResources {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCreateAlertForNewResources.newInstance(<BackgroundJobPayloadForPeriodicCreateAlertForNewResources> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCreateAlertForNewResources) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCreateAlertForNewResources.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCreateAlertForNewResources): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCreateAlertForNewResources.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
